export default __webpack_public_path__ + "static/media/trello_cards.faf922cb.png";